import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { DictOption } from './dicts-oculto.service';

interface SeriesResponse { success: boolean; data: { series: DictOption[] }; }

/**
 * Series usadas pelo portal na entrega das notas, lidas do parametro
 * MV_PNFSER (padrao "S1;S2;S3") em GET /portalnf/dicts/series.
 *
 * A entrega escalona a serie quando o numero ja existe para o fornecedor
 * (a prefeitura reinicia a numeracao da NFS-e a cada exercicio): S1 na
 * primeira entrega, S2 na segunda, S3 na terceira. A tela de inclusao
 * manual usa esta lista no campo Serie - antes fixa em S1/S2 no codigo -
 * para que ampliar o parametro no ERP nao exija deploy do portal.
 *
 * Cache em memoria: a lista vem de um parametro, nao precisa de round-trip
 * a cada abertura de tela.
 */
@Injectable({ providedIn: 'root' })
export class DictsSeriesService {
  private cache$: Observable<DictOption[]> | null = null;

  constructor(private http: HttpClient) {}

  load(): Observable<DictOption[]> {
    if (this.cache$) { return this.cache$; }
    this.cache$ = this.http.get<SeriesResponse>('portalnf/dicts/series').pipe(
      map(r => r.data?.series ?? []),
      shareReplay({ bufferSize: 1, refCount: false })
    );
    return this.cache$;
  }
}
